// extracted by mini-css-extract-plugin
module.exports = {"container":"Brands_container__ypBdU","brandText":"Brands_brandText__vQXRu"};